
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Enum.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum QueryType {
	TaskAction = 0,
	Taskflow = 1,
	Company = 2,
	Order = 3,
	ProductPlan = 4,
	Product = 5
}
export namespace QueryType {
	export function getKeys(): Map<QueryType, string> {
		return new Map([[0, 'TaskAction'], [1, 'Taskflow'], [2, 'Company'], [3, 'Order'], [4, 'ProductPlan'], [5, 'Product']]);
	}
}
